const getLastDaysChartRange = (days: number): { after: string; before: string } => {
    const before = new Date();
    const after = new Date();
    after.setDate(before.getDate() - days);

    return {
        after: after.toISOString(),
        before: before.toISOString()
    };
};

export const getLast30DaysChartRange = (): { after: string; before: string } => getLastDaysChartRange(30);
